import { ErrorCode } from '@exodus/exchange/lib/availability';
import { useSelector } from 'react-redux';

import selectors from '../flux/selectors.js';

type Reason = ReturnType<typeof selectors.exchange.swapAvailability>['reason'];

function getReasonMessage(reason: Reason) {
  if (!reason) {
    return 'Temporarily unavailable.';
  }

  switch (reason.code) {
    case ErrorCode.StateUnavailable:
    case ErrorCode.StateMaybeUnavailable:
      return `Unavailable in the State of ${reason.regionName}.`;
    case ErrorCode.RegionUnavailable:
      return `Unavailable in the Autonomous Republic of ${reason.regionName}.`;
    case ErrorCode.CountryUnavailable:
      return `Unavailable in ${reason.countryName}.`;
    default:
      return 'Temporarily unavailable.';
  }
}

type SwapAvailability = { loading: boolean } & (
  | { value: true; reason?: never }
  | { value: false; reason: string }
);

function useSwapAvailability(): SwapAvailability {
  const { isAvailable, reason } = useSelector(
    selectors.exchange.swapAvailability,
  );
  const loading = !useSelector<unknown, boolean>(selectors.geolocation.loaded);

  if (isAvailable) {
    return { value: true, loading };
  }

  return {
    value: false,
    loading,
    reason: getReasonMessage(reason),
  };
}

export default useSwapAvailability;
